import { call, put, takeEvery, all, fork } from "redux-saga/effects";

// Crypto Redux States
import {
  GET_METRICS
} from "./actionTypes";

//Include Both Helper File with needed methods

import {
  getMetricsSuccess,
  getMetricsFail,
} from "./actions";

import {
  getMetrics,
} from "../../helpers/fakebackend_helper";

function* onGetMetrics(resource_id) {
  const response = yield call(getMetrics, resource_id.payload);
  let final_response = {}
  final_response[resource_id.payload] = response;
  yield put(getMetricsSuccess(final_response));

}

function* metricSaga() {
  yield takeEvery(GET_METRICS, onGetMetrics);
}

export default metricSaga;
